import { IconServiceValue } from "../../../../icons";
import { ModalAnswerType, ModalButtons } from "../styles";
import ButtonDefault from "../../../../form/ButtonDefault";

export default function ResolvePendenciaPagamento({
    profissional,
    pendencia,
    resolvePendencia,
    recusaPendencia
}: {
    profissional: any;
    pendencia: any;
    resolvePendencia: () => void;
    recusaPendencia: () => void;
}) {
    
    function trataValor(valor: number) {
        if (valor.toString().includes('.')) {
            return `R$ ${valor.toString().replace('.', ',')}`;
        } else {
            return `R$ ${valor},00`;
        }
    }

    const defs: any = {
        reembolso: 'reembolso',
        marjoracao: 'majoração',
        adiantamento: 'adiantamento',
    }

    return (
        <ModalAnswerType>
            <div className="title">                                
                {profissional?.nome.split(' ')[0]} {profissional?.id_usuario} solicitou <span>{defs[pendencia?.tipo]}</span> no valor de:
            </div>

            <div className="value">
                <div className="icon"><IconServiceValue /></div>
                { trataValor(pendencia?.valor) }
            </div>

            <div className="justification">Justificado por: "{pendencia?.descricao}"</div>

            <ModalButtons>

                <ButtonDefault
                    className="cancel"
                    onClick={() => { 
                        recusaPendencia(); 
                    }}
                >
                    Recusar
                </ButtonDefault>
                <ButtonDefault
                    className="continue"
                    onClick={() => resolvePendencia()}
                >
                    Aceitar
                </ButtonDefault>

            </ModalButtons>
        </ModalAnswerType>
    )
}